export default __webpack_public_path__ + "static/media/clearIcon.b0e3abc3.svg";